import formQuestionsAreSame from '@opsbase/lib-form/helpers/formQuestionsAreSame';
import i18n from '@opsbase/lib-i18n';
import useQuestionSetFindById from '@opsbase/react-gql-hooks/questionset/useQuestionSetFindById';
import useQuestionSetUpdate from '@opsbase/react-gql-hooks/questionset/useQuestionSetUpdate';
import useCallforward from '@opsbase/react-hooks/useCallforward/useCallforward';
import Dialog from '@opsbase/web-dialogs/Dialog';
import DialogSize from '@opsbase/web-dialogs/Dialog/DialogSize';
import Vertical from '@opsbase/web-layout/Vertical';
import useParams from '@opsbase/web-nav/useParams';
import FormEditor from '@opsbase/web-opform-editor';
import OpTypePicker from '@opsbase/web-pickers/OpTypePicker';
import Text from '@opsbase/web-ui/Text';
import React, { useMemo } from 'react';
import QuestionSetEditCallToPublish from './QuestionSetEditCallToPublish';
export function QuestionSetEditDialog() {
    const { id } = useParams();
    const { data } = useQuestionSetFindById({
        variables: { id },
    });
    const updateQuestionSet = useQuestionSetUpdate();
    const handleChangeField = useCallforward(field => value => data && updateQuestionSet({ id: data === null || data === void 0 ? void 0 : data.id, patch: { [field]: value } }), [data, updateQuestionSet]);
    const formEditor = useMemo(() => () => (React.createElement(FormEditor, { key: 'formEditor' + (data === null || data === void 0 ? void 0 : data.id), mode: 'edit', id: data === null || data === void 0 ? void 0 : data.id, title: data === null || data === void 0 ? void 0 : data.title, form: data === null || data === void 0 ? void 0 : data.form, isQuestionSet: true, isScoreEnabled: true, isScorePublic: true, formConstraints: { root: { max: 1, types: undefined } }, onChangeForm: handleChangeField('form') })), [data, handleChangeField]);
    const settingsEditor = useMemo(() => (React.createElement(Vertical, { padding: true, gutter: true },
        React.createElement(Text, null, i18n.t('questionset-type-description')),
        React.createElement(OpTypePicker, { style: { maxWidth: 400, minWidth: 200 }, white: true, value: data === null || data === void 0 ? void 0 : data.type, onChange: handleChangeField('type') }))), [data, handleChangeField]);
    const isPublishRequired = useMemo(() => {
        if (data === null || data === void 0 ? void 0 : data.form)
            return !formQuestionsAreSame(data.form, data.publishedForm);
    }, [data]);
    return useMemo(() => (React.createElement(Dialog, { size: DialogSize.XFULL_YFULL, sysLangPicker: true, editableTitle: true, title: data ? data.title : i18n.t('loading'), titleAlt: data ? data.titleAlt || {} : {}, onChangeTitle: handleChangeField('title'), onChangeTitleAlt: handleChangeField('titleAlt'), padded: false, scroll: true, childrenRightOfTitle: React.createElement(QuestionSetEditCallToPublish, { questionSet: data, isPublishRequired: isPublishRequired }), tabs: [
            {
                default: true,
                label: i18n.t('questions'),
                route: 'questions',
                component: formEditor,
            },
            {
                label: i18n.t('settings'),
                route: 'settings',
                component: settingsEditor,
            },
        ] })), [data, handleChangeField, isPublishRequired, formEditor, settingsEditor]);
}
export default QuestionSetEditDialog;
